export const UPDATE_LANGUAGE = "ui/UPDATE_LANGUAGE";

export function updateLanguage(language) {
    return {
        type: UPDATE_LANGUAGE,
        language,
    }
}